import axios from 'axios';
import { globalConfig } from 'src/config';
import AxiosMockAdapter from 'axios-mock-adapter';
import globalHooks from 'src/lib/globalHooks';
import { dateFormat } from 'src/constants';
import AlertMessage from '../components/ui-components/AlertMessage';
type AxiosTransformers = (data: any, headers?: any) => any;
const dateTransformer = (data: any): any => {
  if (data instanceof Date) {
    // do your specific formatting here
    return dateFormat(data, 'YYYY-MM-DDTHH:mm:ssZ');
  }
  if (Array.isArray(data)) {
    return data.map(dateTransformer);
  }
  if (typeof data === 'object' && data !== null) {
    return Object.fromEntries(Object.entries(data).map(([key, value]) => [key, dateTransformer(value)]));
  }
  return data;
};
const axiosInstance = axios.create({
  baseURL: globalConfig.baseUrl,
  timeout: 90000,
  transformRequest: [dateTransformer, ...(axios.defaults.transformRequest as AxiosTransformers[])],
});
const axiosMockInstance = axios.create({
  baseURL: globalConfig.baseUrl
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const auth = globalHooks.getHook('auth');
      auth.logout();
      AlertMessage({ type: 'error', msg: 'Session expired' });
      return Promise.reject((
        error.response && error.response.data
      ) || { title: 'Something went wrong' });
    }
    return Promise.reject((
      error.response && error.response.data
    ) || { title: 'Something went wrong' });
  }
);

export const mock = new AxiosMockAdapter(axiosMockInstance, { delayResponse: 0 });

export default axiosInstance;
